/**
 * Gemeinsame Kopfzeile für Sektionen (Überschrift + Meta-Info).
 */
export function SectionHead({
  label,
  meta,
  emphasized,
}: { label: string; meta: string; emphasized?: string }) {
  let display: React.ReactNode = label;
  if (emphasized && label.includes(emphasized)) {
    const parts = label.split(emphasized);
    display = (
      <>
        {parts[0]}
        <em
          className="not-italic"
          style={{ color: 'var(--primary)', fontStyle: 'italic', fontWeight: 400 }}
        >
          {emphasized}
        </em>
        {parts[1]}
      </>
    );
  }
  return (
    <div className="flex items-baseline gap-3 mb-3 px-1">
      <h2
        style={{
          fontFamily: 'var(--f-display)',
          fontSize: 22,
          color: 'var(--ink)',
          fontWeight: 500,
        }}
      >
        {display}
      </h2>
      <span className="text-[11px]" style={{ fontFamily: 'var(--f-mono)', color: 'var(--ink-3)' }}>
        {meta}
      </span>
    </div>
  );
}
